export const UNAUTH_USER = 'unauth_user';

export const LOGIN = 'login_token';
export const LOGIN_SUCCESS = 'login_success';
export const LOGIN_ERROR = 'login_error';

export const SECURE_FETCH_TOKEN = 'secure_fetch_token';
export const SECURE_FETCH_TOKEN_SUCCESS = 'secure_fetch_token_success';
export const SECURE_FETCH_TOKEN_ERROR = 'secure_fetch_token_error';

export const MAGIC_LINK_SEND = 'magic_link_attempt';
export const MAGIC_LINK_SUCCESS = 'magic_link_success';
export const MAGIC_LINK_FAILURE = 'magic_link_failure';

export const REGISTER_USER = "user_register";
export const REGISTER_USER_SUCCEED = "user_register_succeed";
export const REGISTER_USER_FAILED = "user_register_succeed";



// WEBPACK FOOTER //
// ./src/views/auth/_types.js